import { AmplitudeCategories, createTrackerForCategory } from "./amplitude";
import * as SignupFlow from "./SignupFlow";

const trackEvent = createTrackerForCategory(AmplitudeCategories.SignupFlowMay2026);

enum events {
    QuestionAnswered = "QuestionAnswered",
}

async function _getAuthController() {
    // @ts-ignore
    return await import("js/controllers/AuthController").then(module => module.default);
}

export type PossibleAnswers = "start_from_prompt" | "start_from_blank" | "start_from_template" | "explore"

export async function QuestionAnswered({ response } : { response: PossibleAnswers}) {
    const authController = await _getAuthController();
    const user = authController.currentUser;
    const eventProperties = {
        email: user?.email,
        userId: user?.uid,
        workspace_id: "all",
        response
    };
    trackEvent(events.QuestionAnswered, eventProperties, { audit: true });
}

export const TourSteps = {
    1: {
        step_name: "May 2026 Step 1",
        step_number: 3,
    },
    2: {
        step_name: "May 2026 Step 2",
        step_number: 4,
    },
    3: {
        step_name: "May 2026 Step 3",
        step_number: 5,
    },
    4: {
        step_name: "May 2026 Step 4",
        step_number: 6,
    },
};

// Wraps SignupFlow.NavForward
export async function NavForward({ tourPage } : { tourPage: number}) {
    const authController = await _getAuthController();
    const tourProperties = TourSteps[tourPage];

    const user = authController.currentUser;
    const eventProperties = {
        email: user?.email,
        userId: user?.uid,
        workspace_id: "all",
        ...tourProperties,
    };
    SignupFlow.trackEvent(SignupFlow.events.NavForward,
        eventProperties,
        { audit: true });
}
